import { render, staticRenderFns } from "./user-portrait.vue?vue&type=template&id=2c42e853&scoped=true&"
import script from "./user-portrait.vue?vue&type=script&lang=js&"
export * from "./user-portrait.vue?vue&type=script&lang=js&"
import style0 from "./user-portrait.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./user-portrait.vue?vue&type=style&index=1&id=2c42e853&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42e853",
  null
  
)

export default component.exports